export function checkInputTags(event: KeyboardEvent): boolean {
  const target = event.target ? event.target as HTMLInputElement : null;

  return (!!target?.isContentEditable || target?.selectionStart != null) && target?.inputMode !== 'none';
}
